import { render, staticRenderFns } from "./BookingDetail.vue?vue&type=template&id=d72e587a&"
import script from "./BookingDetail.vue?vue&type=script&lang=js&"
export * from "./BookingDetail.vue?vue&type=script&lang=js&"
import style0 from "./BookingDetail.vue?vue&type=style&index=0&id=d72e587a&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports